import { ISelector } from '@omaze/redux';

import { createEmailCaptureSelector } from '../email-capture.factories';
import { IEmailCaptureState, Status } from '../email-capture.state';

export const selectStatus: ISelector<IEmailCaptureState, Status> =
    createEmailCaptureSelector((state: IEmailCaptureState): Status => {
        return state.status;
    });
